module.exports = __webpack_public_path__ + "img/sparckle-star-1-mob.23ce397.svg";